import useSWR from 'swr';
import { outletService } from '../services';

interface IGetOutletServicesParams {
  offset: number;
  size: number;
  outlet_id: number;
  search?: string;
}

export function useOutletServices(params: IGetOutletServicesParams) {
  const execute = async () => {
    const data = await outletService.getOutletServices(params);
    return data;
  };

  const fetchKey = ['get-outlet-services', params];
  const { data, error, isLoading } = useSWR(fetchKey, execute);

  return {
    data,
    error,
    isLoading,
  };
}
